import Table from './Table';
import TableBody from './TableBody/TableBody';
import TableData from './TableData/TableData';
import TableHead from './TableHead/TableHead';
import TableHeader from './TableHeader/TableHeader';
import TableRow from './TableRow/TableRow';
export { Table, TableHead, TableBody, TableRow, TableHeader, TableData };
//# sourceMappingURL=index.js.map